export default "__VITE_ASSET__BaPsjGbw__"